// Inicializador de app Vue
import { start, AppSecurityParams } from '@pjn/vue-core';

// Configuracion de la app
import root from './App.vue';
import routes from './router';
import { store, authStore } from '@/store';
import MenuItem from '@pjn/core/model/app/MenuItem';

// Librerias
import { PLUGINS } from './libs/plugins';
import { GLOBAL_COMPONENTS } from './libs/components';

// Estilos globales del core
import '@pjn/vue-ui/styles/global.styl';

// Estilos globales de esta app
import './styles/main.styl';

// Configurar el menu
const menuItems: MenuItem[] = [
  { id: 'home', label: 'Inicio', icon: 'home', url: '/' },
  { id: 'magistrado', label: 'Magistrados/as', icon: 'person', url: '/magistrados' },
  { id: 'expediente', label: 'Expedientes', icon: 'description', url: '/expedientes' },
  { id: 'denuncia', label: 'Denuncias', icon: 'description', url: '/denuncias' },
];

// Seguridad
const security: AppSecurityParams = {
  authentication: 'check', // 'required' o 'check' o undefined
  privateHome: 'Gestión de Magistrados/as',
  authStore
};

// Inicia la app
start({
  title: 'Denuncias' + (process.env.VUE_APP_ENVIRONMENT !== undefined && process.env.VUE_APP_ENVIRONMENT !== 'PROD' ? ' - ' + process.env.VUE_APP_ENVIRONMENT : ''),
  root,
  menuItems,
  routes,
  store,
  security,
  plugins: PLUGINS,
  components: GLOBAL_COMPONENTS
});
